import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Twelfththeme = ({get_data}) => {
    const navigate = useNavigate();
    const [cartCount, setCartCount] = useState(0);
    const [visibleCategories, setVisibleCategories] = useState(12);

    React.useEffect(() => {
        const updateCount = () => {
            const storedCart = localStorage.getItem('cart');
            const cartItems = storedCart ? JSON.parse(storedCart) : [];
            const count = cartItems.reduce((acc, item) => acc + (item.quantity || 1), 0);
            setCartCount(count);
        };

        updateCount();
        window.addEventListener('storage', updateCount);
        window.addEventListener('cartUpdated', updateCount);

        return () => {
            window.removeEventListener('storage', updateCount);
            window.removeEventListener('cartUpdated', updateCount);
        };
    }, []);

    const [cart, setCart] = useState([]);

        const addToCart = (service) => {
        const storedCart = localStorage.getItem('cart');
        let cartItems = storedCart ? JSON.parse(storedCart) : [];
        
        // Check if item already exists
        const existingItemIndex = cartItems.findIndex(item => 
            (item.id && service.id && item.id === service.id) || 
            (item.service_name && service.service_name && item.service_name === service.service_name)
        );
        
        if (existingItemIndex > -1) {
            cartItems[existingItemIndex].quantity = (cartItems[existingItemIndex].quantity || 1) + 1;
        } else {
            cartItems.push({ ...service, quantity: 1 });
        }

        localStorage.setItem('cart', JSON.stringify(cartItems));
        window.dispatchEvent(new Event('cartUpdated'));
        // alert(`Added ${service.service_name} to cart`);
        navigate('/cart');
    };

    return (
        <>
            <style>{`
        :root {
            /* Palette: Sunset Horizon */
            --primary: #c2410c;       /* Rust Orange */
            --primary-dark: #7c2d12;  /* Deep Red/Brown */
            --primary-light: #fb923c; /* Bright Orange */
            --accent: #fcd34d;        /* Warm Yellow/Gold */
            --bg-body: #fff7ed;       /* Warm Off-white */
            --bg-white: #ffffff;
            --text-dark: #431407;     /* Dark Brown */
            --text-muted: #78350f;    /* Muted Brown */
            
            --font-head: 'Playfair Display', serif;
            --font-body: 'Lato', sans-serif;

            --radius-lg: 16px;
            --shadow-soft: 0 10px 40px -10px rgba(194, 65, 12, 0.15);
            --shadow-hover: 0 20px 40px -10px rgba(194, 65, 12, 0.25);
            
            --gradient-warm: linear-gradient(135deg, #c2410c 0%, #ea580c 100%);
        }

        * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
        }

        body {
            font-family: var(--font-body);
            color: var(--text-dark);
            background-color: var(--bg-body);
            line-height: 1.7;
        }

        h1, h2, h3, h4, h5 {
            font-family: var(--font-head);
            color: var(--primary-dark);
            line-height: 1.25;
            font-weight: 700;
        }

        a {
            text-decoration: none;
            color: inherit;
            transition: all 0.3s ease;
        }

        .container {
            max-width: 1200px;
            margin: 0 auto;
            padding: 0 24px;
        }

        .section {
            padding: 100px 0;
        }
        
        /* Buttons */
        .btn {
            display: inline-block;
            padding: 16px 36px;
            background: var(--gradient-warm);
            color: white;
            border-radius: 50px;
            font-weight: 700;
            letter-spacing: 0.5px;
            box-shadow: 0 5px 15px rgba(234, 88, 12, 0.3);
            border: none;
            cursor: pointer;
            transition: transform 0.3s, box-shadow 0.3s;
        }

        .btn:hover {
            transform: translateY(-3px);
            box-shadow: 0 10px 25px rgba(234, 88, 12, 0.4);
        }

        .btn-outline {
            display: inline-block;
            padding: 14px 34px;
            background: transparent;
            color: var(--primary);
            border: 2px solid var(--primary);
            border-radius: 50px;
            font-weight: 700;
            cursor: pointer;
        }
        
        .btn-outline:hover {
            background: var(--primary);
            color: white;
        }

        /* Top Bar */
        .top-bar {
            background-color: var(--primary-dark);
            color: #ffedd5;
            padding: 12px 0;
            font-size: 0.9rem;
        }

        .top-bar .container {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
        
        .top-contact {
            display: flex;
            gap: 25px;
        }

        .top-contact span i {
            margin-right: 8px;
            color: var(--accent);
        }

        /* Navbar */
        .navbar {
            background-color: rgba(255, 255, 255, 0.95);
            backdrop-filter: blur(10px);
            padding: 20px 0;
            position: sticky;
            top: 0;
            z-index: 1000;
            box-shadow: 0 4px 20px rgba(0,0,0,0.03);
        }

        .navbar .container {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        .brand {
            font-size: 2rem;
            font-weight: 700;
            background: var(--gradient-warm);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
        }

        .nav-menu {
            display: flex;
            gap: 35px;
            list-style: none;
        }

        .nav-menu a {
            font-weight: 700;
            color: var(--text-dark);
            font-size: 1rem;
        }

        .nav-menu a:hover {
            color: var(--primary);
        }

        /* Hero */
        .hero {
            position: relative;
            padding: 180px 0 120px;
            background: linear-gradient(to bottom, #fff7ed 0%, #ffedd5 100%);
            overflow: hidden;
        }

        .hero::before {
            content: '';
            position: absolute;
            top: -100px;
            right: -100px;
            width: 600px;
            height: 600px;
            background: radial-gradient(circle, rgba(251, 146, 60, 0.2) 0%, rgba(255, 255, 255, 0) 70%);
            border-radius: 50%;
        }

        .hero-grid {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 60px;
            align-items: center;
            position: relative;
            z-index: 2;
        }

        .hero-content h1 {
            font-size: 4.5rem;
            margin-bottom: 25px;
            line-height: 1.1;
        }

        .hero-content p {
            font-size: 1.25rem;
            color: var(--text-muted);
            margin-bottom: 40px;
            max-width: 90%;
        }

        .hero-img {
            position: relative;
        }

        .hero-img img {
            width: 100%;
            border-radius: var(--radius-lg);
            box-shadow: var(--shadow-soft);
            transform: rotate(2deg);
        }
        
        .hero-img::after {
            content: '';
            position: absolute;
            top: 20px;
            left: -20px;
            right: 20px;
            bottom: -20px;
            border: 2px solid var(--primary);
            border-radius: var(--radius-lg);
            z-index: -1;
            transform: rotate(-2deg);
        }

        /* Common Section Header */
        .section-header {
            text-align: center;
            margin-bottom: 70px;
        }
        
        .section-tag {
            display: inline-block;
            padding: 6px 16px;
            background-color: #ffedd5;
            color: var(--primary);
            border-radius: 30px;
            font-size: 0.85rem;
            font-weight: 700;
            text-transform: uppercase;
            letter-spacing: 1px;
            margin-bottom: 20px;
        }

        .section-header h2 {
            font-size: 3rem;
        }

        /* Services */
        .services-section {
            background-color: var(--bg-white);
        }

        .service-grid {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 40px;
        }

        .service-card {
            background: var(--bg-body);
            padding: 40px;
            border-radius: var(--radius-lg);
            transition: all 0.4s ease;
            position: relative;
            overflow: hidden;
            border: 1px solid rgba(194, 65, 12, 0.05);
        }

        .service-card:hover {
            transform: translateY(-10px);
            box-shadow: var(--shadow-soft);
            background: white;
            border-color: transparent;
        }

        .service-icon {
            width: 70px;
            height: 70px;
            background: white;
            border-radius: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 25px;
            box-shadow: 0 5px 15px rgba(0,0,0,0.05);
            font-size: 2rem;
            color: var(--primary);
        }
        
        .service-icon img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 20px;
        }

        .service-card h3 {
            font-size: 1.5rem;
            margin-bottom: 15px;
        }

        .service-card p {
            color: var(--text-muted);
            margin-bottom: 25px;
        }

        /* Products */
        .products-grid {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            gap: 30px;
        }

        .product-card {
            background: var(--bg-white);
            border-radius: var(--radius-lg);
            overflow: hidden;
            box-shadow: var(--shadow-soft);
            transition: 0.4s;
        }
        
        .product-card:hover {
            transform: translateY(-5px);
            box-shadow: var(--shadow-hover);
        }

        .product-image {
            height: 250px;
            position: relative;
            overflow: hidden;
        }
        
        .product-image img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: transform 0.6s;
        }
        
        .product-card:hover .product-image img {
            transform: scale(1.1);
        }
        
        .product-price {
            position: absolute;
            bottom: 15px;
            right: 15px;
            background: var(--bg-white);
            color: var(--primary);
            padding: 5px 12px;
            border-radius: 8px;
            font-weight: 700;
            box-shadow: 0 4px 10px rgba(0,0,0,0.1);
        }

        .product-details {
            padding: 25px;
        }

        .product-details h3 {
            font-size: 1.2rem;
            margin-bottom: 10px;
        }
        
        .product-actions {
            margin-top: 20px;
            display: flex;
            flex-direction: column;
            gap: 10px;
        }

        /* Reviews */
        .review-section {
            background-color: var(--primary-dark);
            color: #ffedd5;
            background-image: radial-gradient(#9a3412 1px, transparent 1px);
            background-size: 30px 30px;
        }

        .review-section .section-header h2, 
        .review-section .section-header p {
            color: #ffedd5;
        }
        
        .review-section .section-tag {
            background-color: rgba(255, 237, 213, 0.1);
            color: var(--accent);
        }

        .review-slider {
            display: flex;
            overflow-x: auto;
            gap: 30px;
            padding-bottom: 40px;
            scrollbar-width: none;
        }

        .review-card {
            min-width: 350px;
            background: rgba(255, 255, 255, 0.05);
            backdrop-filter: blur(10px);
            padding: 30px;
            border-radius: var(--radius-lg);
            border: 1px solid rgba(255, 255, 255, 0.1);
        }

        .stars {
            color: var(--accent);
            margin-bottom: 15px;
            font-size: 1.2rem;
        }

        .review-text {
            font-style: italic;
            margin-bottom: 20px;
            font-size: 1.05rem;
            line-height: 1.6;
            opacity: 0.9;
        }

        .reviewer-info {
            display: flex;
            align-items: center;
            gap: 15px;
        }
        
        .reviewer-avatar {
            width: 45px;
            height: 45px;
            background: var(--primary);
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: 700;
            color: white;
        }

        /* Footer */
        footer {
            background-color: #fff7ed;
            padding: 80px 0 30px;
            color: var(--text-dark);
            border-top: 1px solid #fed7aa;
        }

        .footer-grid {
            display: grid;
            grid-template-columns: 2fr 1fr 1fr 1fr;
            gap: 50px;
            margin-bottom: 60px;
        }

        .footer-brand {
            font-family: var(--font-head);
            font-size: 2rem;
            font-weight: 700;
            color: var(--primary);
            margin-bottom: 20px;
            display: block;
        }

        .footer-col h4 {
            margin-bottom: 25px;
            font-size: 1.1rem;
        }

        .footer-links li {
            margin-bottom: 12px;
        }
        
        .footer-links a:hover {
            color: var(--primary);
            text-decoration: underline;
        }

        .social-links {
            display: flex;
            gap: 15px;
            margin-top: 25px;
        }
        
        .social-links a {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            background: white;
            display: flex;
            align-items: center;
            justify-content: center;
            box-shadow: 0 4px 10px rgba(0,0,0,0.05);
            color: var(--primary);
            transition: 0.3s;
        }
        
        .social-links a:hover {
            background: var(--primary);
            color: white;
            transform: translateY(-3px);
        }

        @media (max-width: 900px) {
            .hero-grid {
                grid-template-columns: 1fr;
                text-align: center;
            }
            .hero-img {
                order: -1;
            }
            .service-grid, .products-grid, .footer-grid {
                grid-template-columns: 1fr;
            }
            .navbar .nav-menu, .top-bar {
                display: none;
            }
        }
            `}</style>
            
            <link rel="preconnect" href="https://fonts.googleapis.com" />
            <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="true" />
            <link href="https://fonts.googleapis.com/css2?family=Lato:wght@400;700&family=Playfair+Display:ital,wght@0,400;0,600;0,700;1,400&display=swap" rel="stylesheet" />

            {/* Top Bar */}
            <div className="top-bar">
                <div className="container">
                    <div className="top-contact">
                        {get_data.business_location_name && <span><i>📍</i> {get_data.business_location_name}</span>}
                        {get_data.mobile && <span><i>📞</i> {get_data.mobile}</span>}
                    </div>
                     <div>
                        {get_data.email && <span><i>✉️</i> {get_data.email}</span>}
                    </div>
                </div>
            </div>

            {/* Navbar */}
            <nav className="navbar">
                <div className="container">
                    <a href="#" className="brand">{get_data.service_name}</a>
                    <ul className="nav-menu">
                        <li><a href="#">Home</a></li>
                        <li><a href="#about">About</a></li>
                        <li><a href="#services">Services</a></li>
                        <li><a href="#products">Products</a></li>
                        <li><a href="#reviews">Testimonials</a></li>
                    </ul>
                    <a href="#contact" className="btn" style={{padding: '10px 25px', fontSize: '0.9rem'}}>Contact Us</a>
                        <a href="/cart" style={{display: 'flex', alignItems: 'center', position: 'relative', marginLeft: '15px', color: 'inherit', textDecoration: 'none'}}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <circle cx="9" cy="21" r="1"></circle>
                                <circle cx="20" cy="21" r="1"></circle>
                                <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
                            </svg>
                            {cartCount > 0 && (
                                <span style={{
                                    position: 'absolute',
                                    top: '-8px',
                                    right: '-10px',
                                    background: 'red',
                                    color: 'white',
                                    borderRadius: '50%',
                                    width: '20px',
                                    height: '20px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '0.7rem',
                                    fontWeight: 'bold'
                                }}>
                                    {cartCount}
                                </span>
                            )}
                        </a>
                </div>
            </nav>
            
             {/* Hero */}
            <header className="hero">
                <div className="container">
                    <div className="hero-grid">
                        <div className="hero-content">
                            <span className="section-tag" style={{background: '#fff', border: '1px solid #fed7aa'}}>Welcome to {get_data.service_name}</span>
                            <h1>Experience the Warmth of Excellence</h1>
                            <p>We believe in delivering services that not only meet your needs but also warm your heart. Quality, dedication, and passion are at our core.</p>
                            <div style={{display: 'flex', gap: '15px', justifyContent: 'center'}}>
                                <a href="#services" className="btn">Our Services</a>
                                <a href="#about" className="btn-outline">Learn More</a>
                            </div>
                        </div>
                        <div className="hero-img">
                            <img src="https://images.unsplash.com/photo-1469334031218-e382a71b716b?ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80" alt="Warmth" />
                        </div>
                    </div>
                </div>
            </header>
            
            {/* About */}
            <section className="section" id="about">
                <div className="container">
                    <div className="section-header">
                        <span className="section-tag">Who We Are</span>
                        <h2>A Story of Passion</h2>
                    </div>
                    <div style={{maxWidth: '800px', margin: '0 auto', textAlign: 'center'}}>
                        <p style={{fontSize: '1.2rem', color: 'var(--text-muted)', marginBottom: '30px'}}>
                            {get_data.service_name} started with a simple vision: to bring warmth and reliability to every interaction. Over the years, we have grown into a community relying on trust and superior quality.
                        </p>
                         <p style={{fontSize: '1.1rem', color: 'var(--text-muted)'}}>
                            Our approach is personal. We treat every client like family, ensuring that every service and product we deliver meets the high standards we'd expect for ourselves.
                        </p>
                    </div>
                </div>
            </section>
            
             {/* Services */}
            <section className="section services-section" id="services">
                <div className="container">
                    <div className="section-header">
                        <span className="section-tag">What We Offer</span>
                        <h2>Curated Services</h2>
                    </div>
                    <div className="service-grid">
                        {get_data.all_categories && get_data.all_categories.slice(0, visibleCategories).map((item, index) => (
                            <div className="service-card" key={index}>
                                <div className="service-icon">
                                    {item.icon ? (
                                        <img 
                                            src={item.icon.startsWith('http') ? item.icon : `https://reliep-images.s3.ap-south-1.amazonaws.com/public/storage/${item.icon}`}
                                            alt={item.name}
                                        />
                                    ) : (
                                        <span>☀</span>
                                    )}
                                </div>
                                <h3>{item.name}</h3>
                                <p>{item.description || 'Description coming soon.'}</p>
                                <div style={{display: 'flex', gap: '10px'}}>
                                    <a href={`tel:${get_data.mobile}`} className="btn-outline" style={{padding: '8px 20px', fontSize: '0.8rem', flex: 1, textAlign: 'center'}}>Call</a>
                                    <a href="#contact" className="btn" style={{padding: '8px 20px', fontSize: '0.8rem', flex: 1, textAlign: 'center', boxShadow: 'none'}}>Enquiry</a>
                                </div>
                            </div>
                        )) }
                    { get_data.all_categories && visibleCategories < get_data.all_categories.length && (
                        <div style={{textAlign: 'center', marginTop: '40px'}}>
                            <button 
                                onClick={() => setVisibleCategories(prev => prev + 6)} 
                                className="btn"
                            >
                                Show More
                            </button>
                        </div>
                    )}
                    </div>
                </div>
            </section>
            
            {/* Products */}
             <section className="section" id="products">
                <div className="container">
                    <div className="section-header">
                        <span className="section-tag">Shop</span>
                        <h2>Premium Collection</h2>
                    </div>
                    <div className="products-grid">
                        {get_data.product_services && get_data.product_services.map((item, index) => (
                            <div className="product-card" key={index}>
                                <div className="product-image">
                                     {item.featured_image ? (<img 
                                        src={item.featured_image && item.featured_image.startsWith('http') ? item.featured_image : `https://reliep-snaps.s3.ap-south-1.amazonaws.com/featured/${item.featured_image}`} 
                                        alt={item.service_name}
                                    />) : (<div className="" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f0f0f0', fontSize: '1.5rem', fontWeight: 'bold', color: '#555',  }}>{(item.service_name || 'PR').slice(0, 2).toUpperCase()}</div>)}
                                    {item.price && <span className="product-price">₹{item.price}</span>}
                                </div>
                                <div className="product-details">
                                    <h3>{item.service_name}</h3>
                                    <p style={{fontSize: '0.9rem', color: 'var(--text-muted)'}}>{item.description || 'Quality item.'}</p>
                                    <div className="product-actions">
                                        <button onClick={() => addToCart(item)} className="btn" style={{width: '100%', boxSizing: 'border-box', textAlign: 'center'}}>Add to Cart</button>
                                         <div style={{display: 'flex', gap: '10px'}}>
                                            <a href={`tel:${get_data.mobile}`} className="btn-outline" style={{padding: '8px', fontSize: '0.8rem', flex: 1, textAlign: 'center'}}>Call</a>
                                            <a href="#contact" className="btn-outline" style={{padding: '8px', fontSize: '0.8rem', flex: 1, textAlign: 'center'}}>Enquiry</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            
            {/* Browse Categories Section */}
            <section className="section dedicated-categories" style={{padding: '80px 0', background: '#fff'}}>
                <div className="container">
                    <div className="section-header">
                        <span className="section-tag">Discover</span>
                        <h2>Browse Categories</h2>
                    </div>
                    <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '30px'}}>
                        {get_data.all_categories && get_data.all_categories.slice(0, visibleCategories).map((cat, index) => (
                            <div key={index} style={{background: '#fff7ed', padding: '30px', borderRadius: '16px', textAlign: 'center', transition: '0.3s', border: '1px solid rgba(194, 65, 12, 0.1)'}}>
                                {cat.icon ? (
                                    <img src={cat.icon.startsWith('http') ? cat.icon : `https://reliep-images.s3.ap-south-1.amazonaws.com/public/storage/${cat.icon}`} 
                                         style={{width: '70px', height: '70px', objectFit: 'contain', marginBottom: '20px', borderRadius: '50%'}} alt={cat.name} />
                                ) : (
                                    <div style={{width: '70px', height: '70px', background: '#fff', borderRadius: '50%', margin: '0 auto 20px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold', color: '#c2410c'}}>
                                        {(cat.name || 'C').charAt(0)}
                                    </div>
                                )}
                                <h3 style={{fontSize: '1.2rem', marginBottom: '15px', color: '#431407'}}>{cat.name}</h3>
                                <div style={{display: 'flex', gap: '10px'}}>
                                    <a href={`tel:${get_data.mobile}`} className="btn-outline" style={{flex: 1, padding: '10px', fontSize: '0.8rem', textAlign: 'center'}}>Call</a>
                                    <a href="#contact" className="btn" style={{flex: 1, padding: '10px', fontSize: '0.8rem', textAlign: 'center', boxShadow: 'none'}}>Enquiry</a>
                                </div>
                            </div>
                        )) }
                    { get_data.all_categories && visibleCategories < get_data.all_categories.length && (
                        <div style={{textAlign: 'center', marginTop: '40px'}}>
                            <button 
                                onClick={() => setVisibleCategories(prev => prev + 6)} 
                                className="btn"
                            >
                                Show More
                            </button>
                        </div>
                    )}
                    </div>
                </div>
            </section>

            {/* Reviews */}
            <section className="section review-section" id="reviews">
                <div className="container">
                     <div className="section-header">
                        <span className="section-tag">Testimonials</span>
                        <h2>Voices of Happiness</h2>
                    </div>
                    {get_data.review_ratings && get_data.review_ratings.length > 0 ? (
                        <div className="review-slider">
                            {get_data.review_ratings.map((review, index) => (
                                <div className="review-card" key={index}>
                                    <div className="stars">
                                         {review.rating && <span>{'★'.repeat(Math.round(review.rating)) + '☆'.repeat(5 - Math.round(review.rating))}</span>}
                                    </div>
                                    <p className="review-text">"{review.review || 'Wonderful experience.'}"</p>
                                    <div className="reviewer-info">
                                        <div className="reviewer-avatar">{review.user_name ? review.user_name.charAt(0) : 'G'}</div>
                                        <div>
                                            <h5 style={{margin: 0, color: 'white'}}>{review.user_name || 'Guest'}</h5>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : (
                         <div style={{textAlign: 'center', opacity: 0.7}}><p>No reviews yet.</p></div>
                    )}
                </div>
            </section>
            
             {/* Footer */}
            <footer id="contact">
                <div className="container">
                    <div className="footer-grid">
                        <div className="footer-col">
                            <span className="footer-brand">{get_data.service_name}</span>
                            <p style={{lineHeight: 1.6}}>Bringing warmth and excellence to your doorstep. We are committed to your satisfaction.</p>
                            <div className="social-links">
                                {get_data.facebook && <a href={get_data.facebook}>f</a>}
                                {get_data.twitter && <a href={get_data.twitter}>t</a>}
                                {get_data.instagram && <a href={get_data.instagram}>ig</a>}
                            </div>
                        </div>
                        <div className="footer-col">
                            <h4>Explore</h4>
                            <ul className="footer-links">
                                <li><a href="#about">About Us</a></li>
                                <li><a href="#services">Services</a></li>
                                <li><a href="#products">Products</a></li>
                            </ul>
                        </div>
                         <div className="footer-col">
                            <h4>Services</h4>
                            <ul className="footer-links">
                                <li><a href="#services">All Services</a></li>
                                <li><a href="#products">Our Shop</a></li>
                            </ul>
                        </div>
                        <div className="footer-col">
                            <h4>Contact</h4>
                            <ul className="footer-links">
                                <li>📍 {get_data.business_location_name}</li>
                                <li>📞 {get_data.mobile}</li>
                                <li>✉️ {get_data.email}</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    );
};

export default Twelfththeme;
